import { GLOBAL_API_BASE_URL, VERIFY_API_BASE_URL } from '@chk/env-variables';
import type {
  UseMutationParams,
  UseMutationResult,
} from '@utility/checkout-utils';
import {
  CURRENT_SERVICE_TYPE,
  SERVICE_TYPE,
  useMutation,
} from '@utility/checkout-utils';

export function useScaMutation<ResponseType, RequestType>(
  mutationParams: UseMutationParams
): UseMutationResult<ResponseType, RequestType> {
  const baseUrl =
    CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS_DEPRECATED
      ? VERIFY_API_BASE_URL
      : GLOBAL_API_BASE_URL;

  return useMutation<ResponseType, RequestType>({
    ...mutationParams,
    baseUrl,
    shouldTrackException: false,
  });
}
